import ApiClient from './client';


const path = require('path');

 class OrganisationsAPI extends ApiClient {
  async getOrganisationsTypes() {
    const url = path.join(`${this.ORGANISATION_API_PATH}`, `organisation-types/`);
    let response;
    try {
      response = await this.get(url);
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  }
};
const organisationsAPI = new OrganisationsAPI();
export default organisationsAPI;
